module.exports = __webpack_public_path__ + "static/media/chikitsamitra.bd8a8032.png";